import React from "react";
import { Icon } from "react-fa";
import HeroVideo, { HeroWithVideo } from "components/HeroVideo";
import rapidoVideo from "../rapidovideo.mp4";
import logoGraphic from "images/ATS-logo-graphic.png";

const SplashVideo = (props) => (
  <HeroWithVideo color="dark" size="fullheight">
    <HeroVideo src={rapidoVideo} />
    <div
      className="container has text centered"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "center"
      }}
    >
      <img src={logoGraphic} alt="Accratronics Seals, LLC. Logo" width="128" height="128" />
      <h1 className="title is-size-1-desktop is-size-3-touch is-size-4-mobile tk-univia-pro">
        Accratronics Seals, LLC.
      </h1>
      <h2 className="subtitle is-size-4-desktop is-size-6-touch">
        Manufacturers of Precision Glass-to-Metal Hermetic Seals and Precision
        Machining
      </h2>
      <Icon
        name="chevron-down"
        size="2x"
        style={{ marginTop: "8rem", position: "absolute" }}
        onClick={props.onClick}
      />
    </div>
  </HeroWithVideo>
);

export default SplashVideo;



// WEBPACK FOOTER //
// ./src/pages/Home/components/SplashVideo.js